import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    campaignResultList: null,
    campaignCount: 0,
    sorting: 'lastModifiedDate',
    ordering: 'desc'
};

const slice = createSlice({
    name: 'smartCreator',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        campaignListInit(state, action) {
            state.campaignResultList = action.payload.smartCampaignList;
            state.campaignCount = action.payload.total
        },
        campaignListAppend(state, action) {
            state.campaignResultList = [...state.campaignResultList, ...action.payload.smartCampaignList];
        },
        updateSorting(state, action) {
            state.sorting = action.payload;
        },
        updateSortingOrder(state, action) {
            state.ordering = action.payload;
        },
        resetCampaignList(state) {
            state.campaignResultList = null;
            state.campaignCount = 0;
        },
        resetStore(state) {
            state.error = null;
            state.campaignResultList = null;
            state.campaignCount = 0;
            state.sorting = 'lastModifiedDate';
            state.ordering = 'desc';
        }
    }
});

export default slice.reducer;

export function clearStore(data, callback) {
    return () => {
        dispatch(slice.actions.resetStore());
        if (callback) {
            callback();
        }
    };
}

export function getCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/smart-campaign/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (data.currentPage === 1) {
                dispatch(slice.actions.campaignListInit(response.data));
            } else if (data.currentPage > 1) {
                dispatch(slice.actions.campaignListAppend(response.data));
            }
            

            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateSortingField(data) {
    return () => {
        dispatch(slice.actions.updateSorting(data));
    };
}

export function updateOrdering(data) {
    return () => {
        dispatch(slice.actions.updateSortingOrder(data));
    };
}

export function clearCampaignList(data, callback) {
    return () => {
        dispatch(slice.actions.resetCampaignList());
        if (callback) {
            callback();
        }
    };
}
